(() => {
  'use strict';

  const MUG_VARIANT = 51090442453208;
  const THRESHOLD_CENTS = 30000000;
  const MARKER = '_mc_auto_gift';
  const SESSION_KEY = 'mc_auto_mug_manual_dismiss_v2';
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  let timer;
  let working = false;
  let needsAnotherPass = false;
  let deniedFingerprint = '';
  let observedCart = null;

  const isGift = (item) => Number(item.variant_id) === MUG_VARIANT &&
    item.properties?.[MARKER] === '1';
  const isMug = (item) => Number(item.variant_id) === MUG_VARIANT;

  const fingerprint = (cart) => `${cart.token || ''}|` + cart.items
    .filter((item) => !isMug(item))
    .map((item) => `${item.variant_id}:${item.quantity}:${item.original_line_price}`)
    .sort().join('|');

  const readSavedFingerprint = () => {
    try { return sessionStorage.getItem(SESSION_KEY) || ''; } catch { return ''; }
  };
  const saveFingerprint = (value) => {
    try { sessionStorage.setItem(SESSION_KEY, value); } catch { /* storage blocked */ }
  };

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin', cache: 'no-store'
    });
    if (!response.ok) throw new Error(`Error leyendo carrito (${response.status})`);
    return response.json();
  }

  async function post(endpoint, data) {
    const response = await fetch(`${root}cart/${endpoint}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      const details = await response.json().catch(() => ({}));
      throw new Error(details.description || `Error al actualizar carrito (${response.status})`);
    }
    return response.json();
  }

  async function updateDrawer() {
    const drawer = document.querySelector('mc-cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') {
      await drawer.refresh();
    }
  }

  async function synchronize() {
    if (working) { needsAnotherPass = true; return; }
    working = true;
    try {
      const cart = await getCart();
      observedCart = cart;
      if (cart.currency !== 'COP') return;

      const qualifyingCents = cart.items.reduce((sum, item) =>
        sum + (isMug(item) ? 0 : Number(item.original_line_price || 0)), 0);
      const eligible = qualifyingCents >= THRESHOLD_CENTS;
      const signature = fingerprint(cart);
      const autoGift = cart.items.find(isGift);
      const manualMug = cart.items.some((item) => isMug(item) && !isGift(item));

      if (!eligible) {
        saveFingerprint('');
        deniedFingerprint = '';
      }

      if (autoGift && (!eligible || manualMug || Number(autoGift.final_line_price) > 0)) {
        if (eligible && Number(autoGift.final_line_price) > 0) {
          deniedFingerprint = signature;
        }
        await post('change', { id: autoGift.key, quantity: 0 });
        await updateDrawer();
        return;
      }

      if (autoGift && autoGift.quantity > 1) {
        await post('change', { id: autoGift.key, quantity: 1 });
        await updateDrawer();
        return;
      }

      if (!eligible || autoGift || manualMug || deniedFingerprint === signature ||
          readSavedFingerprint() === signature) return;

      await post('add', {
        items: [{ id: MUG_VARIANT, quantity: 1, properties: { [MARKER]: '1' } }]
      });
      const updated = await getCart();
      observedCart = updated;
      const addedGift = updated.items.find(isGift);
      if (!addedGift) throw new Error('Shopify no devolvió el Mug automático');

      // Never retain an automatically added, full-price mug.
      if (Number(addedGift.final_line_price) !== 0) {
        deniedFingerprint = signature;
        await post('change', { id: addedGift.key, quantity: 0 });
        console.warn('Monte Capra: no se aplicó el 100% al Mug; se retiró del carrito.');
      } else {
        saveFingerprint('');
        if (addedGift.quantity > 1) {
          await post('change', { id: addedGift.key, quantity: 1 });
        }
      }
      await updateDrawer();
    } catch (error) {
      console.warn('Monte Capra - regalo automático:', error);
    } finally {
      working = false;
      if (needsAnotherPass) {
        needsAnotherPass = false;
        schedule();
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(synchronize, 300);
  }

  function markManualRemoval(key) {
    const gift = observedCart?.items?.find((item) =>
      isGift(item) && String(item.key) === String(key)
    );

    if (gift) {
      saveFingerprint(fingerprint(observedCart));
    }
  }

  window.MontecapraAutoMug = { schedule, markManualRemoval };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) schedule();
  });
})();